import gql from 'graphql-tag';

export default gql`
    mutation UploadImageToLoad($input: UploadImageToLoadInput) {
        uploadImageToLoad(input: $input) {
            errors
        }
    }
`;
